/**
 * Substitutes [param] placeholders in a manual route template.
 * Each value is encoded as a single path segment so characters like `/`, spaces,
 * or `&` in slugs do not create extra segments or break :param matching.
 */
export function replaceRouteTemplateParams(template: string, params: Record<string, unknown>): string {
  return template.replace(/\[(\w+)\]/g, (match, paramName: string) => {
    const value = params[paramName]
    if (value === undefined || value === null) {
      return match
    }
    return encodeURIComponent(String(value))
  })
}
